import React from 'react';

const richFormattingValues = { b: (...chunks: string[]): JSX.Element => <b style={{ fontWeight: 500 }}>{chunks}</b> };

export default richFormattingValues;
